<template>
  <div class="runner-types-page">
    <div class="page-header">
      <h2 class="page-title">跑手类型管理</h2>
      <button @click="openAddModal" class="add-btn">+ 添加类型</button>
    </div>

    <div class="filter-bar">
      <div class="search-box">
        <input
          type="text"
          v-model="searchKey"
          placeholder="搜索类型名称或编码..."
          class="search-input"
        />
        <button @click="search" class="search-btn">搜索</button>
        <button @click="resetSearch" class="reset-btn">重置</button>
      </div>
    </div>

    <div class="table-container">
      <table class="runner-types-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>类型名称</th>
            <th>类型编码</th>
            <th>类型描述</th>
            <th>每日接单上限</th>
            <th>结算周期</th>
            <th>服务费率(%)</th>
            <th>需健康证</th>
            <th>排序</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in runnerTypes" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.code }}</td>
            <td class="desc-cell">{{ item.description || '-' }}</td>
            <td>{{ item.daily_order_limit == null ? '-' : item.daily_order_limit }}</td>
            <td>{{ formatSettleCycle(item.settle_cycle) }}</td>
            <td>{{ item.service_fee_rate == null ? '-' : item.service_fee_rate }}</td>
            <td>{{ item.require_health_cert === 1 ? '是' : '否' }}</td>
            <td>{{ item.sort_order == null ? '-' : item.sort_order }}</td>
            <td>
              <span :class="'status status-' + item.status">
                {{ item.status === 1 ? '启用' : '禁用' }}
              </span>
            </td>
            <td>
              <button @click="openEditModal(item)" class="action-btn edit">编辑</button>
              <button
                @click="toggleStatus(item)"
                class="action-btn"
                :class="item.status === 1 ? 'disable' : 'enable'"
              >
                {{ item.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="handleDelete(item)" class="action-btn delete">删除</button>
            </td>
          </tr>
          <tr v-if="runnerTypes.length === 0">
            <td colspan="11" class="empty-cell">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="currentPage--" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button :disabled="currentPage === totalPages" @click="currentPage++" class="page-btn">下一页</button>
    </div>

    <!-- 新增 / 编辑弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingItem ? '编辑跑手类型' : '添加跑手类型' }}</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>类型名称 <span class="required">*</span></label>
            <input v-model="form.name" type="text" class="form-control" placeholder="如：专职 / 兼职 / 临时" />
          </div>
          <div class="form-group">
            <label>类型编码 <span class="required">*</span></label>
            <input v-model="form.code" type="text" class="form-control" placeholder="如：full_time / part_time / temp" />
          </div>
          <div class="form-group">
            <label>类型描述</label>
            <input v-model="form.description" type="text" class="form-control" placeholder="可选" />
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>每日接单上限（0表示无限制）</label>
              <input v-model.number="form.daily_order_limit" type="number" min="0" class="form-control" placeholder="0" />
            </div>
            <div class="form-group">
              <label>结算周期</label>
              <select v-model.number="form.settle_cycle" class="form-control">
                <option :value="0">T+0</option>
                <option :value="1">T+1</option>
                <option :value="2">T+2</option>
                <option :value="3">T+3</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>服务费率(%)</label>
              <input v-model.number="form.service_fee_rate" type="number" step="0.01" min="0" max="100" class="form-control" placeholder="0.00" />
            </div>
            <div class="form-group">
              <label>需健康证</label>
              <select v-model.number="form.require_health_cert" class="form-control">
                <option :value="0">否</option>
                <option :value="1">是</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>排序</label>
              <input v-model.number="form.sort_order" type="number" min="0" class="form-control" placeholder="数字越小越靠前" />
            </div>
            <div class="form-group">
              <label>状态</label>
              <select v-model.number="form.status" class="form-control">
                <option :value="1">启用</option>
                <option :value="0">禁用</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">取消</button>
          <button @click="save" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRunnerTypeList,
  createRunnerType,
  updateRunnerType,
  deleteRunnerType
} from '@/api/runnerTypes'

export default {
  name: 'RunnerTypes',
  data() {
    return {
      searchKey: '',
      currentPage: 1,
      totalPages: 1,
      total: 0,
      runnerTypes: [],
      showModal: false,
      editingItem: null,
      form: this.emptyForm()
    }
  },
  watch: {
    currentPage() {
      this.loadList()
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    emptyForm() {
      return {
        name: '',
        code: '',
        description: '',
        daily_order_limit: 0,
        settle_cycle: 1,
        service_fee_rate: 0,
        require_health_cert: 0,
        sort_order: 0,
        status: 1
      }
    },
    async loadList() {
      try {
        const params = { page: this.currentPage, pageSize: 20 }
        const keyword = this.searchKey.trim()
        if (keyword) {
          // 简单处理：名称或编码，优先编码精确匹配
          params.code = keyword
        }
        const res = await getRunnerTypeList(params)
        if (res && res.code === 0 && res.data) {
          const pageData = res.data
          this.runnerTypes = pageData.list || []
          this.total = pageData.total || 0
          this.totalPages = Math.max(1, Math.ceil(this.total / (pageData.pageSize || 20)))
        }
      } catch (error) {
      }
    },
    search() {
      this.currentPage = 1
      this.loadList()
    },
    resetSearch() {
      this.searchKey = ''
      this.currentPage = 1
      this.loadList()
    },
    formatSettleCycle(val) {
      const map = { 0: 'T+0', 1: 'T+1', 2: 'T+2', 3: 'T+3' }
      return val == null ? '-' : (map[val] || val)
    },
    openAddModal() {
      this.editingItem = null
      this.form = this.emptyForm()
      this.showModal = true
    },
    openEditModal(item) {
      this.editingItem = item
      this.form = {
        name: item.name || '',
        code: item.code || '',
        description: item.description || '',
        daily_order_limit: item.daily_order_limit == null ? 0 : item.daily_order_limit,
        settle_cycle: item.settle_cycle == null ? 1 : item.settle_cycle,
        service_fee_rate: item.service_fee_rate == null ? 0 : item.service_fee_rate,
        require_health_cert: item.require_health_cert == null ? 0 : item.require_health_cert,
        sort_order: item.sort_order == null ? 0 : item.sort_order,
        status: item.status == null ? 1 : item.status
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editingItem = null
      this.form = this.emptyForm()
    },
    async save() {
      if (!this.form.name.trim()) {
        alert('请输入类型名称')
        return
      }
      if (!this.form.code.trim()) {
        alert('请输入类型编码')
        return
      }

      // 去掉空值字段
      const payload = {}
      Object.keys(this.form).forEach(key => {
        const v = this.form[key]
        if (v !== '' && v !== null && v !== undefined) {
          payload[key] = v
        }
      })

      try {
        if (this.editingItem) {
          await updateRunnerType(this.editingItem.id, payload)
          alert('更新成功')
        } else {
          await createRunnerType(payload)
          alert('添加成功')
        }
        this.closeModal()
        this.loadList()
      } catch (error) {
        const msg = error && error.response && error.response.data && error.response.data.message
        alert(msg || '保存失败，请稍后重试')
      }
    },
    async toggleStatus(item) {
      const action = item.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}类型 ${item.name} 吗？`)) {
        try {
          const newStatus = item.status === 1 ? 0 : 1
          await updateRunnerType(item.id, { status: newStatus })
          item.status = newStatus
        } catch (error) {
          alert('更新状态失败')
        }
      }
    },
    async handleDelete(item) {
      if (confirm(`确定要删除类型 ${item.name} 吗？此操作不可恢复。`)) {
        try {
          await deleteRunnerType(item.id)
          alert('删除成功')
          this.loadList()
        } catch (error) {
          alert('删除失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.runner-types-page {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.filter-bar {
  margin-bottom: 16px;
  padding: 14px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.search-box {
  display: flex;
  gap: 10px;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 280px;
}

.search-btn,
.reset-btn {
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.search-btn {
  background: #3498db;
  color: #fff;
}

.reset-btn {
  background: #ecf0f1;
  color: #333;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.runner-types-table {
  width: 100%;
  border-collapse: collapse;
}

.runner-types-table th,
.runner-types-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}

.runner-types-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.desc-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-cell {
  text-align: center;
  color: #999;
  padding: 30px 0;
}

.status {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
}

.status-1 { background: #e8f5e9; color: #2ecc71; }
.status-0 { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
  color: #fff;
}

.action-btn.edit { background: #3498db; }
.action-btn.disable { background: #e74c3c; }
.action-btn.enable { background: #2ecc71; }
.action-btn.delete { background: #95a5a6; }

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 560px;
  max-width: 92%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-row .form-group {
  flex: 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.required {
  color: #e74c3c;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
